"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PusherEvent = void 0;
var PusherEvent;
(function (PusherEvent) {
    // User Events
    PusherEvent["BillingCancelled"] = "billing_cancelled";
    PusherEvent["BillingFailed"] = "billing_failed";
    PusherEvent["BillingSuccessful"] = "billing_successful";
    PusherEvent["BillingUpdate"] = "billing_update";
    PusherEvent["PhoneVerify"] = "phone_verify";
    PusherEvent["ZipDocumentDownload"] = "zip_documents_download";
    PusherEvent["ConvertPdfToImagesDone"] = "convert_pdf_to_images_done";
    PusherEvent["ConvertPdfToImagesFailed"] = "convert_pdf_to_images_failed";
    // Document Status Events
    PusherEvent["Archived"] = "archived";
    PusherEvent["Draft"] = "draft";
    PusherEvent["Hardbounced"] = "hardbounced";
    PusherEvent["Importing"] = "importing";
    PusherEvent["Lost"] = "lost";
    PusherEvent["Processing"] = "processing";
    PusherEvent["Recalled"] = "recalled";
    PusherEvent["Rejected"] = "rejected";
    PusherEvent["Reviewed"] = "reviewed";
    PusherEvent["Scheduled"] = "scheduled";
    PusherEvent["Sealed"] = "sealed";
    PusherEvent["Sent"] = "sent";
    PusherEvent["Signed"] = "signed";
    PusherEvent["Signedwithoutverification"] = "signedwithoutverification";
    // Document Events
    PusherEvent["Approved"] = "approved";
    PusherEvent["Comment"] = "comment";
    PusherEvent["Converting"] = "converting";
    PusherEvent["Created"] = "created";
    PusherEvent["Deleted"] = "deleted";
    PusherEvent["DocumentImportDone"] = "document_import_done";
    PusherEvent["DocumentImportFailed"] = "document_import_failed";
    PusherEvent["DocumentPageImageDone"] = "document_page_image_done";
    PusherEvent["DocumentPageImagesStarted"] = "document_page_images_started";
    PusherEvent["DocumentUpdated"] = "document_updated";
    PusherEvent["DownloadDocumentResponse"] = "download_document_response";
    PusherEvent["Expired"] = "expired";
    PusherEvent["ExpirationUpdate"] = "expiration_update";
    PusherEvent["Forwarded"] = "forwarded";
    PusherEvent["Imported"] = "imported";
    PusherEvent["Published"] = "published";
    PusherEvent["Unpublished"] = "unpublished";
    PusherEvent["SealDone"] = "seal_done";
    PusherEvent["SealFailed"] = "seal_failed";
    PusherEvent["SealStatusUpdated"] = "seal_status_updated";
    PusherEvent["Viewed"] = "viewed";
    PusherEvent["RoleChanged"] = "role_changed";
    PusherEvent["EditAfterSend"] = "edit_after_send";
    PusherEvent["RecipientAdded"] = "recipient_added";
    // Track Events
    PusherEvent["TrackClick"] = "track_click";
    PusherEvent["TrackEditor"] = "track_editor";
    PusherEvent["TrackPage"] = "track_page";
    PusherEvent["TrackVideo"] = "track_video";
    PusherEvent["TrackVisit"] = "track_visit";
    // Video Events
    PusherEvent["ConvertVideoDone"] = "convert_video_done";
    PusherEvent["ConvertVideoFailed"] = "convert_video_failed";
    PusherEvent["ConvertVideoStart"] = "convert_video_start";
    // Recipient Events
    PusherEvent["SMSStatus"] = "sms_status";
    PusherEvent["VerifiedEid"] = "verified_eid";
    PusherEvent["CriiptoStatusUpdate"] = "criipto_status_update";
    // Contact Events
    PusherEvent["UploadContactsDone"] = "upload_contacts_done";
    PusherEvent["UploadContactsFailed"] = "upload_contacts_failed";
    // Handle Uploaded Attachment Events
    PusherEvent["HandleUploadedAttachmentDone"] = "handle_uploaded_attachment_done";
    PusherEvent["HandleUploadedAttachmentFail"] = "handle_uploaded_attachment_failed";
    // Conversation events
    PusherEvent["Typing"] = "typing";
    PusherEvent["StoppedTyping"] = "stopped_typing";
    PusherEvent["MessageCreated"] = "message_created";
    PusherEvent["MessageUpdated"] = "message_updated";
    PusherEvent["MessageDeleted"] = "message_deleted";
    PusherEvent["ConversationCreated"] = "conversation_created";
    PusherEvent["ConversationUpdated"] = "conversation_updated";
    PusherEvent["ParticipantAdded"] = "participant_added";
    PusherEvent["ParticipantRemoved"] = "participant_removed";
    PusherEvent["MessageRead"] = "message_read";
    // Entity events
    PusherEvent["CommunicationTemplateUpdated"] = "communication_template_updated";
    // E2E Event
    PusherEvent["Test"] = "test";
    // Contextual comments
    PusherEvent["ContextualCommentCreated"] = "contextual_comment_created";
    PusherEvent["ContextualCommentUpdated"] = "contextual_comment_updated";
    PusherEvent["ContextualCommentRead"] = "contextual_comment_read";
    PusherEvent["ContextualCommentReplyCreated"] = "contextual_comment_reply_created";
    PusherEvent["ContextualCommentReplyUpdated"] = "contextual_comment_reply_updated";
    PusherEvent["ContextualCommentReplyRead"] = "contextual_comment_reply_read";
    PusherEvent["ContextualCommentEditorSelectionCreated"] = "contextual_comment_editor_selection_created";
    // EidEasy events
    PusherEvent["EidEasyPrepareSuccess"] = "eid_easy_prepare_success";
    PusherEvent["EidEasyPrepareFail"] = "eid_easy_prepare_fail";
    PusherEvent["EidEasySignSuccess"] = "eid_easy_sign_success";
    PusherEvent["EidEasySignFail"] = "eid_easy_sign_fail";
})(PusherEvent = exports.PusherEvent || (exports.PusherEvent = {}));
